/**
 * The device's own calendar date as YYYY-MM-DD.
 *
 * toISOString() returns the UTC day, which is the previous day for anyone east
 * of UTC during their early morning (in India, before 05:30). Expense dates,
 * "today" checks and cutoffs must follow the phone's timezone instead.
 */
export const toLocalYMD = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default toLocalYMD;
